import { render } from "./QualityControl.vue?vue&type=template&id=634a624f&scoped=true"
import script from "./QualityControl.vue?vue&type=script&lang=js"
export * from "./QualityControl.vue?vue&type=script&lang=js"

import "./QualityControl.vue?vue&type=style&index=0&id=634a624f&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634a624f"]])

export default __exports__